export function getFormattedDateArray(lastDay, count) {
  let [day, month, year] = lastDay;
  let currentDate = new Date(year, month, day);
  const dateArray = [];

  for (let i = 0; i < count; i += 1) {
    const formattedDate = currentDate.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
    });
    dateArray.push(formattedDate);
    currentDate.setDate(currentDate.getDate() - 1);
  }

  dateArray.reverse();
  return dateArray;
}

export function unixToDate(time) {
  const date = new Date(time * 1000);

  return date.toLocaleString('en-CA', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  })
    .replace(/,/, '')
    .replace(/\//g, '/')
    .replace(/-/g, '/');
}

export function getDatesFromPeriod(period, previous) {
  const now = new Date();
  let end = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  let start;

  if (period === 'Last 30 days') {
    start = new Date(end);
    start.setDate(start.getDate() - 30 + 1);

    if (previous) {
      end = new Date(start);
      end.setDate(end.getDate() - 1);
      start.setDate(start.getDate() - 30 + 1);
    }
  } else if (period === 'Last 6 months') {
    start = new Date(end.getFullYear(), end.getMonth() - 6, end.getDate());
  } else {
    const targetMonth = new Date(`${period} 1, ${now.getFullYear()}`);
    if (targetMonth > now) {
      targetMonth.setFullYear(targetMonth.getFullYear() - 1);
    }

    start = new Date(
      targetMonth.getFullYear(),
      targetMonth.getMonth() + (previous ? -1 : 0),
      1
    );

    end = new Date(
      targetMonth.getFullYear(),
      targetMonth.getMonth() + (previous ? 0 : 1),
      0
    );
  }

  return { start, end };
}

export function generatePeriodOptions() {
  const now = new Date();
  const months = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  const result = ['Last 30 days'];

  for (let i = 0; i < 6; i += 1) {
    const monthIndex = (now.getMonth() - i + 12) % 12;
    result.push(months[monthIndex]);
  }

  result.push('Last 6 months');

  return result;
}
